import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService } from 'src/app/services/dialog.service';
import { LayoutService } from 'src/app/services/layout.service';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { SignalRService } from 'src/app/services/signalr.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { ToastService } from 'src/app/services/toasts.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-refresh-products-modal',
    templateUrl: './refresh-products-modal.component.html',
    styleUrl: './refresh-products-modal.component.scss',
    imports: [FormsModule],
})
export class RefreshProductsModalComponent implements OnInit {
  fields: string[] = [];
  availableFields: string[] = [
    'Description',
    'NationalId',
    'MaxStack',
    'CasePack',
    'Unit',
    'Uos',
    'Manufacturer',
    'Brand',
    'Category',
    'Segment',
    'Family',
    'Base',
    'FlowOrder',
    'Dimensions',
    'TrayConfig',
    'Orientation',
    'ShelfPosition',
    'SqueezeFactor',
    'CPI',
    'Labels',
    'Price',
    'SalesData',
    'Status',
    'Ranged'
  ];
  selectedFields: { [key: string]: boolean } = {};

  constructor(
    public activeModal: NgbActiveModal,
    private dialogService: DialogService,
    private planogramService: PlanogramService,
    private planogramApiService: PlanogramApiService,
    private signalRService: SignalRService,
    private layoutService: LayoutService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    // Initialize selectedFields object
    this.availableFields.forEach(field => {
      this.selectedFields[field] = false;
    });
  }
  
  toggleAll() {
    this.availableFields.forEach(field => {
      this.selectedFields[field] = true;
    });
    this.updateFields();
  }

  toggleNone() {
    this.availableFields.forEach(field => {
      this.selectedFields[field] = false;
    });
    this.updateFields();
  }

  updateFields() {
    this.fields = Object.keys(this.selectedFields)
      .filter(key => this.selectedFields[key]);
  }

  async confirm() {
  try {
    const response = await this.planogramApiService.refreshProducts(this.fields);
    const { replacedBarcodes, products } = response;

    // Normal success path
    if (replacedBarcodes.length === 0) {
      this.toastService.show('Products refreshed successfully', {
        classname: 'bg-success text-light p-3 fs-5',
        delay: 3000,
      });
      const dimensionsChanged = this.layoutService.refreshProducts(products, this.fields);
      if (dimensionsChanged) {
        this.dialogService.showWarning(
          'The dimensions of one more products have changed, layout recalculation recommended.',
          'Product Dimensions Changed'
        );
      }
      this.activeModal.close(products);
      return;
    }

    // If barcodes were replaced
    const message =
      `Some products were replaced due to updated data:\n\n` +
      replacedBarcodes.join('<br/>') +
      `<br/><br/>Reloading the planogram is recommended to reflect the changes.`;

    const shouldReload = await this.dialogService.showWarningConfirmation(
      'Products Replaced',
      message
    );

    if (shouldReload) {
      this.toastService.show('Reloading planogram...', {
        classname: 'bg-info text-light p-3 fs-5',
        delay: 3000,
      });
      let state = this.planogramService.getPlanogramState();
      if(state)
        this.signalRService.loadPlanogramState(state);
    } 
    else {
      const dimensionsChanged = this.layoutService.refreshProducts(products, this.fields);
      if (dimensionsChanged) {
        this.dialogService.showWarning(
          'The dimensions of one more products have changed, layout recalculation recommended.',
          'Product Dimensions Changed'
        );
      }
    }

    this.activeModal.close(products);
  } catch (error) {
    this.toastService.show('Failed to refresh products', {
      classname: 'bg-danger text-light p-3 fs-5',
      delay: 3000,
    });
    console.error('Refresh products error:', error);
  }
}

  cancel(): void {
    this.activeModal.close(null);
  }
}
